import {NgModule} from '@angular/core';
import {CoreModule} from 'features/core/core.module';
import {PD_ENTITY_PROVIDER} from './pd.entity-provider';
import {PdConfigPage} from './page/pd-config/pd-config.page';
import {
    PdPartnerObjectComponent
} from './component/object-components/pd-partner-object-component/pd-partner-object.component';
import {
    PdPartnerProcessingStatusComponent
} from './component/private-components/pd-partner-processing-status/pd-partner-processing-status.component';

/**
 * pd module — contract events per receiving partner (Datenaustausch-Partner).
 *
 * One config page (pd/config) and the object component of pd.PdPartner. The object component is resolved
 * through PD_ENTITY_PROVIDER, never routed.
 */
@NgModule({
    declarations: [
        PdConfigPage,
        PdPartnerObjectComponent,
        PdPartnerProcessingStatusComponent,
    ],
    exports: [
        PdConfigPage,
        PdPartnerObjectComponent,
    ],
    imports: [CoreModule],
    providers: [PD_ENTITY_PROVIDER]
})
export class PdModule {
}
